import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
export const store = new Vuex.Store({state:{token:null},mutations:{token(state,value){state.token=value;}}});
export const api = axios.create({baseURL:'/api/'});
let csrfToken='';
export function setCsrf(value){csrfToken=value||'';}
api.interceptors.request.use(config=>{if(csrfToken)config.headers['X-CSRFToken']=csrfToken;return config;});
api.interceptors.response.use(response=>response,error=>{if(error.response&&error.response.status===401&&!error.config.url.startsWith('auth/'))store.commit('token',null);return Promise.reject(error);});
